export default __webpack_public_path__ + "static/media/logo-white.1fa96dea.svg";